import { UseQueryResult } from '@tanstack/react-query';

import { API_QUERY_KEYS, getRespondedOnTimeReport, useBaseReport } from 'api';
import { ReportResponse } from 'types';

export const useRespondedOnTimeReport = (): UseQueryResult<ReportResponse> =>
  useBaseReport(API_QUERY_KEYS.getRespondedOnTimeReport, getRespondedOnTimeReport);
